import React from "react";
import DatePicker from "react-datepicker";
import { Button, Card, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { CloseSvg } from "../../../components/CommonSvg";
import { DATE_FORMATER } from "../../../constant/commonConstants";

function UserLogFilter({
    filter,
    setFilter,
    handelShowFIlter,
    /* page-supplied buttons that belong with the filter, sitting beside
       Clear all - see UserLogs' Delete Logs */
    actions,
}) {
    const handelClearAll = () => {
        setFilter({ fromDate: null, toDate: null });
    };

    return (
        <Card className="filter_section vendor_log_filter">
            <CardBody>
                <h6 className="separate-head">Filter</h6>
                <div className="vendor_log_filter_actions">
                    {actions}
                    <Button
                        className="clear_btn btn-primary"
                        style={{ color: "black" }}
                        onClick={handelClearAll}
                    >
                        Clear all
                    </Button>
                </div>

                <form className="hra-create">
                    <Row>
                        <Col className="no-floating-label">
                            <FormGroup>
                                <DatePicker
                                    id="fromDate"
                                    className="form-control"
                                    dateFormat={DATE_FORMATER}
                                    placeholderText="From date"
                                    selected={filter.fromDate}
                                    maxDate={filter.toDate || new Date()}
                                    isClearable
                                    onChange={(date) =>
                                        setFilter({ ...filter, fromDate: date })
                                    }
                                />
                                <Label className="form-label" htmlFor="fromDate">
                                    From
                                </Label>
                            </FormGroup>

                            {/* absolutely positioned against .filter_section, so it
                                sits in the card's corner wherever it is written */}
                            <Button
                                className="my-tooltip cancel_filter"
                                data-tooltip-content={"Close filter"}
                                color="link"
                                onClick={handelShowFIlter}
                            >
                                <CloseSvg />
                            </Button>
                        </Col>

                        <Col className="no-floating-label">
                            <FormGroup>
                                <DatePicker
                                    id="toDate"
                                    className="form-control"
                                    dateFormat={DATE_FORMATER}
                                    placeholderText="To date"
                                    selected={filter.toDate}
                                    minDate={filter.fromDate}
                                    maxDate={new Date()}
                                    isClearable
                                    onChange={(date) =>
                                        setFilter({ ...filter, toDate: date })
                                    }
                                />
                                <Label className="form-label" htmlFor="toDate">
                                    To
                                </Label>
                            </FormGroup>
                        </Col>
                        <Col></Col>
                    </Row>
                </form>
            </CardBody>
        </Card>
    );
}

export default UserLogFilter;
